module.exports = __webpack_public_path__ + "images/987b5c4f0ff3279fd4775978e8fea4ab.svg";